export default __webpack_public_path__ + "static/media/remove.b031497e.svg";